import { render, staticRenderFns } from "./organizationGroup.vue?vue&type=template&id=8ea3a628&"
import script from "./organizationGroup.vue?vue&type=script&lang=js&"
export * from "./organizationGroup.vue?vue&type=script&lang=js&"
import style0 from "./organizationGroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports